import type { PendingAttachment } from 'src/components/chat'

import type { ChatSendOptions } from './useChatSession'

export type SendWithFilesDeps = {
  /** The chips the composer shows when the user presses send. */
  items: PendingAttachment[]
  hide: (localIds: string[]) => void
  unhide: (localIds: string[]) => void
  release: (localIds: string[]) => void
  send: (prompt: string, options: ChatSendOptions) => Promise<void>
  restoreDraft: (prompt: string) => void
}

/**
 * Sends the ready files with the message. Their chips hide while the message
 * is in flight and are released only on the `run` event (Squad bound them to
 * the run); any other ending — a refusal, a network error, a stop before the
 * run — gives them back to the composer for the next try.
 */
export const sendWithFiles = async (
  prompt: string,
  { items, hide, unhide, release, send, restoreDraft }: SendWithFilesDeps
) => {
  const ready = items.flatMap((item) =>
    item.status === 'ready' && item.attachment
      ? [{ localId: item.localId, attachment: item.attachment }]
      : []
  )
  const ids = ready.map((item) => item.localId)
  let accepted = false

  if (ids.length) hide(ids)

  await send(prompt, {
    onRefused: () => restoreDraft(prompt),
    ...(ready.length
      ? {
          attachments: ready.map((item) => item.attachment),
          onRunAccepted: () => {
            accepted = true
            release(ids)
            unhide(ids)
          }
        }
      : {})
  })

  if (!accepted && ids.length) unhide(ids)
}
